import { render } from "./pagination.vue?vue&type=template&id=66c1daca&scoped=true"
import script from "./pagination.vue?vue&type=script&lang=js"
export * from "./pagination.vue?vue&type=script&lang=js"

import "./pagination.vue?vue&type=style&index=0&id=66c1daca&scoped=true&lang=css"

import exportComponent from "/Users/victorbello/Documents/Tizeti/Hotspot/eutelsat_branch/Expresswifi_os/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66c1daca"]])

export default __exports__